import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { useState, useEffect } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton, MenuItem, Box, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
export function ChatSettingsDialog({ hasSysPromptPermission, open, handleClose, handleAccept, defaultSystPrompt, defaultTemperature, defaultModel, }) {
    const [systPrompt, setSystPrompt] = useState({
        value: defaultSystPrompt,
        error: "",
    });
    const [temperature, setTemperature] = useState({
        value: defaultTemperature,
        error: "",
    });
    const [model, setModel] = useState(defaultModel);
    useEffect(() => {
        setSystPrompt((prev) => (Object.assign(Object.assign({}, prev), { value: defaultSystPrompt })));
    }, [defaultSystPrompt]);
    useEffect(() => {
        setTemperature((prev) => (Object.assign(Object.assign({}, prev), { value: defaultTemperature })));
    }, [defaultTemperature]);
    useEffect(() => {
        setModel(defaultModel);
    }, [defaultModel]);
    const closeAndReturnUndefined = () => {
        handleClose();
    };
    const closeAndReturnData = () => {
        const _systPrompt = hasSysPromptPermission
            ? systPrompt.value
            : defaultSystPrompt;
        const _model = hasSysPromptPermission ? model : defaultModel;
        handleAccept(_systPrompt, temperature.value, _model);
    };
    const handlePromptInputChange = (value) => {
        let error = "";
        const maxLen = 32767;
        if (value.length > maxLen)
            error = `This must be ${maxLen} characters or fewer.`;
        else
            error = "";
        setSystPrompt({
            value,
            error,
        });
    };
    const handleTemperatureInputChange = (value) => {
        let error = "";
        setTemperature({
            value: Number(value),
            error,
        });
    };
    const handleModelChange = (value) => {
        setModel(value);
    };
    const disableConfirm = !!systPrompt.error || !!temperature.error;
    const availableModels = [
        { value: "gemma-lora", label: "gemma-lora" },
        { value: "gpt-4o", label: "gpt-4o" },
        { value: "gpt-4.1-mini", label: "gpt-4.1-mini" },
        { value: "gpt-4.1", label: "gpt-4.1" },
    ];
    return (_jsxs(Dialog, Object.assign({ open: open, onClose: closeAndReturnUndefined, PaperProps: {
            sx: { minWidth: hasSysPromptPermission ? "500px" : "auto" },
        } }, { children: [_jsxs(DialogTitle, Object.assign({ textAlign: "center" }, { children: ["Settings", _jsx(IconButton, Object.assign({ "aria-label": "close", onClick: closeAndReturnUndefined, sx: {
                            position: "absolute",
                            right: 4,
                            top: 4,
                        } }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(DialogContent, Object.assign({ sx: { py: 0 } }, { children: _jsxs(Box, Object.assign({ sx: { display: "flex", flexDirection: "column", gap: 1 } }, { children: [hasSysPromptPermission && (_jsxs(_Fragment, { children: [_jsx(TextField, { fullWidth: true, maxRows: 15, sx: { my: 1 }, label: "System Prompt", variant: "outlined", error: !!systPrompt.error, helperText: systPrompt.error, value: systPrompt.value, size: "small", multiline: true, onChange: (e) => handlePromptInputChange(e.target.value), autoFocus: true }), _jsx(TextField, Object.assign({ select: true, label: "Model", fullWidth: true, value: model, size: "small", onChange: (e) => {
                                        handleModelChange(e.target.value);
                                    } }, { children: availableModels.map((option) => (_jsx(MenuItem, Object.assign({ value: option.value }, { children: option.label }), option.value))) }))] })), _jsx(TextField, { error: !!temperature.error, helperText: temperature.error, sx: { my: 1 }, label: "Temperature", variant: "outlined", type: "number", value: temperature.value, size: "small", onChange: (e) => handleTemperatureInputChange(e.target.value), autoFocus: true, InputProps: {
                                inputProps: {
                                    min: 0,
                                    step: 0.1,
                                },
                            } })] })) })), _jsx(DialogActions, Object.assign({ sx: { justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ variant: "contained", disabled: disableConfirm, onClick: closeAndReturnData }, { children: "Confirm" })) }))] })));
}
